import { StoreSlice } from '../types';

export declare interface ICameraSlice {
  cameraAccessConsented: boolean;
  setCameraAccessConsented: (v: boolean) => void;
  [key: string]: unknown;
}

const createSettingsPanelSlice: StoreSlice<ICameraSlice> = (set) => ({
  cameraAccessConsented: null,
  setCameraAccessConsented: (v) => set((state) => { state.cameraAccessConsented = v; })
});

export default createSettingsPanelSlice;
